export const FRONT_REGEX_CONFIG = {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    zip: /^\d{5}$|^\d{5}-\d{4}$/,
    zipShort: /^\d{5}$/,
    npi: /^\d{10}$/,
    taxId: /^\d{9}$|^\d{2}-\d{7}$/,
    date: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/, // mm/dd/yyyy
    ein: /^\d{9}$/,
    einWithDash: /^\d{2}-?\d{7}$/,
    usPhoneNumber: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
    singleUpperLetter: /[A-Z]/,
    singleNumber: /\d/,
    singleSpecialCharacter: /[\^$*.[\]{}()?"!@#%&\/\\,><':;|_~`=+\-]/,
    integer: /^\d+$/,
}
